<template>
    <CFormCheck
        :model-value="modelValue"
        @update:model-value="updateValue"
    />
</template>

<script>
import { CFormCheck } from '@coreui/vue-pro'

export default {
    name: 'DFormCheck',
    components: { CFormCheck },
    props: {
        modelValue: {
            default: null,
            type: Boolean
        }
    },
    emits: ['update:modelValue'],
    methods: {
        updateValue (event) {
            this.$emit('update:modelValue', event)
        }
    }
}
</script>

<style lang="scss">
.form-check label {
    margin-top: 3px
}
</style>
